import { motion } from "framer-motion";
import { Phone, ArrowRight, MapPin, ShieldCheck, SprayCan } from "lucide-react";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="grain-overlay bg-[#081C15] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-28 md:pt-36 pb-16 md:pb-24 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <motion.div
          className="lg:col-span-7"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37] mb-5" data-testid="hero-eyebrow">
            IMR Poultry Solutions Inc.
          </p>
          <h1 className="font-display font-black tracking-tight leading-[0.95] text-5xl sm:text-6xl lg:text-7xl" data-testid="hero-headline">
            <span className="text-[#D4AF37]">CLEANER BARNS.</span>
            <br />
            STRONGER FARMS.
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#D8E2DC] max-w-xl leading-relaxed" data-testid="hero-subtext">
            Professional cleaning &amp; sanitation solutions for today's poultry producers —
            serving barns across British Columbia, Canada.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href="tel:+19709023321"
              data-testid="hero-call-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-[#D4AF37] text-[#081C15] px-7 py-3.5 font-display font-bold text-sm hover:brightness-110 transition duration-200 shadow-[0_4px_24px_rgba(212,175,55,0.35)]"
            >
              <Phone size={17} />
              Call Iancu — 1-970-902-3321
            </a>
            <a
              href="#contact"
              data-testid="hero-quote-button"
              className="inline-flex items-center gap-2.5 rounded-full border-2 border-white/25 text-white px-7 py-3.5 font-display font-bold text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
            >
              Request Service Info
              <ArrowRight size={17} />
            </a>
          </div>
          <p className="mt-4 text-sm text-[#D8E2DC]/80" data-testid="hero-secondary-contact">
            Or reach Matt Toews:{" "}
            <a href="tel:+12367770697" data-testid="hero-call-matt" className="font-semibold text-[#D4AF37] hover:brightness-110 transition duration-200">
              +1 (236) 777-0697
            </a>
          </p>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#D8E2DC]">
            <span className="inline-flex items-center gap-2" data-testid="hero-badge-area">
              <MapPin size={15} className="text-[#D4AF37]" /> Across British Columbia
            </span>
            <span className="inline-flex items-center gap-2" data-testid="hero-badge-biosecurity">
              <ShieldCheck size={15} className="text-[#D4AF37]" /> Biosecurity-focused
            </span>
            <span className="inline-flex items-center gap-2" data-testid="hero-badge-cleaning">
              <SprayCan size={15} className="text-[#D4AF37]" /> Professional crews
            </span>
          </div>
        </motion.div>

        <motion.div
          className="lg:col-span-5 relative"
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
        >
          <div className="absolute -inset-4 bg-[#D4AF37]/10 rounded-2xl rotate-2" aria-hidden="true" />
          <img
            src="/imr-flyer.jpg"
            alt="IMR Poultry Solutions — Cleaner Barns. Stronger Farms."
            data-testid="hero-image"
            className="relative rounded-xl w-full object-cover shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
          />
        </motion.div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs uppercase tracking-[0.18em] text-[#D8E2DC]/70 font-semibold">
          <SprayCan size={14} className="text-[#D4AF37]" />
          <span>Manure Removal</span>
          <span className="text-[#D4AF37]">•</span>
          <span>Barn Cleaning</span>
          <span className="text-[#D4AF37]">•</span>
          <span>Agricultural Sanitation</span>
          <span className="text-[#D4AF37]">•</span>
          <span>Biosecurity Protocols</span>
        </div>
      </div>
    </section>
  );
};
